"use client";

import type { Networkish } from "@/types";
import React from "react";

import useChainInfo from "@/hooks/useChainInfo";
import { SupLoader, SupText } from "@repo/core-ui";

import Image from "next/image";
import { twMerge } from "tailwind-merge";

export function UiLabelChain(
  chain: Networkish,
  showText: boolean = true,
  showIcon: boolean = true,
  showLabel: boolean = false,
  customCssClass: string | undefined = undefined,
  width: number = 20
) {
  const { data: chainData, isLoading } = useChainInfo(chain);
  return isLoading ? (
    <SupLoader isSmall />
  ) : (
    chainData &&
      (showIcon ? (
        <div className={twMerge("sup-badge-chain", customCssClass && customCssClass)}>
          <small className={twMerge(!showLabel && "hidden")}>Chain</small>
          <Image unoptimized={true} width={`${width}`} height={`${width}`} src={chainData.icon} alt={chainData.name} />
          <SupText variant="subtitle1" className={twMerge("ml-2 leading-4", !showText && "hidden")}>
            {chainData.name}
          </SupText>
        </div>
      ) : (
        <>{chainData.name}</>
      ))
  );
}
